module.exports = __webpack_public_path__ + "img/trafficgeneration.e8b1c22f.png";